module.exports = __webpack_public_path__ + "img/tip-icon3.1c2d618a.png";